import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import { RegistroUsuarioDTO } from "types/dto/RegistroUsuarioDTO";
import { SelectOptionType } from "types/select/SelectOptionType";
import * as yup from "yup";

export const AgendarContatoGestaoCobrancaCadastroSchema = yup.object().shape({
  responsavelAgendamento: yup
    .mixed<SelectOptionType<RegistroUsuarioDTO>>()
    .required(mensagemDeErroPadrao("Responsável pelo agendamento")),

  dataAgendamento: yup
    .date()
    .required(mensagemDeErroPadrao("Data do agendamento"))
    .typeError("Informe uma data válida"),

  horarioAgendamento: yup
    .date()
    .required(mensagemDeErroPadrao("Horário do agendamento"))
    .typeError("Informe um horário válido"),
});
